const bastei = require('./landmarks/bastei.png');
const belvedere = require('./landmarks/belvedere.png');
const honig = require('./landmarks/honig.png');
const houtwerf = require('./landmarks/houtwerf.png');
const kapel = require('./landmarks/kapel.png');
const kazerne = require('./landmarks/kazerne.png');
const looimolen = require('./landmarks/looimolen.png');
const lux = require('./landmarks/lux.png');
const masker = require('./landmarks/masker.png');
const oversteek = require('./landmarks/oversteek.png');
const schouwburg = require('./landmarks/schouwburg.png');
const snelbinder = require('./landmarks/snelbinder.png');
const station = require('./landmarks/station.png');
const stevenskerk = require('./landmarks/stevenskerk.png');
const toren = require('./landmarks/toren.png');
const vasim = require('./landmarks/vasim.png');
const waalbrug = require('./landmarks/waalbrug.png');
const wijncentrum = require('./landmarks/wijncentrum.png');
const wolfsberg = require('./landmarks/wolfsberg.png');

const casparmodez = require('./landmarks/arnhem/casparmodez.png');
const eusebius = require('./landmarks/arnhem/eusebius.png');
const gemaal = require('./landmarks/arnhem/gemaal.png');
const johnfrost = require('./landmarks/arnhem/johnfrost.png');
const lazyking = require('./landmarks/arnhem/lazyking.png');
const rozet = require('./landmarks/arnhem/rozet.png');
const stationArnhem = require('./landmarks/arnhem/station.png');
const walburgiskerk = require('./landmarks/arnhem/walburgiskerk.png');

const boot = require('./icons/boot.png');
const koelinks = require('./icons/koelinks.png');
const koerechts = require('./icons/koerechts.png');
const paardlinks = require('./icons/paardlinks.png');
const paardrechts = require('./icons/paardrechts.png');
const paraplu = require('./icons/paraplu.png');
const slippers = require('./icons/slippers.png');
const vrachtschip = require('./icons/vrachtschip.png');
const druif = require('./icons/druif.png');
const hert = require('./icons/hert.png');
const tent = require('./icons/tent.png');
const vos = require('./icons/vos.png');
const zwijn = require('./icons/zwijn.png');

export const icons = [
  // Landmarks
  // Nimmaaaaaaa de gekste
  { coordinates: [5.870021694482887, 51.84899515338691], name: 'bastei', size: 0.2, src: bastei },
  { coordinates: [5.867311693205579, 51.84509384482561], name: 'lux', size: 0.2, src: lux },
  { coordinates: [5.863833111704508, 51.85498809864754], name: 'masker', size: 0.2, src: masker },
  { coordinates: [5.8531679475969725, 51.84317052636794], name: 'station', size: 0.2, src: station },
  { coordinates: [5.862810126152027, 51.84800789273851], name: 'stevenskerk', size: 0.2, src: stevenskerk },
  { coordinates: [5.857624940832608, 51.847436468460955], name: 'toren', size: 0.2, src: toren },
  { coordinates: [5.872504270898503, 51.84738971778674], name: 'belvedere', size: 0.2, src: belvedere },
  { coordinates: [5.846999339684686, 51.853132561540605], name: 'honig', size: 0.2, src: honig },
  { coordinates: [5.856214405675303, 51.82687525922816], name: 'houtwerf', size: 0.2, src: houtwerf },
  { coordinates: [5.869781018439113, 51.84811466435639], name: 'kapel', size: 0.2, src: kapel },
  { coordinates: [5.872695635513253, 51.83411942454444], name: 'kazerne', size: 0.2, src: kazerne },
  { coordinates: [5.842875995518597, 51.83654989063126], name: 'looimolen', size: 0.2, src: looimolen }, // Note;this is in nimma
  { coordinates: [5.857900325124177, 51.84277231420711], name: 'schouwburg', size: 0.2, src: schouwburg },
  { coordinates: [5.841635828785087, 51.85869826766677], name: 'oversteek', size: 0.3, src: oversteek },
  { coordinates: [5.836408220545479, 51.85549582653957], name: 'vasim', size: 0.2, src: vasim },
  { coordinates: [5.871078909765146, 51.85153112275245], name: 'waalbrug', size: 0.3, src: waalbrug },
  { coordinates: [5.85729, 51.853132], name: 'snelbinder', size: 0.3, src: snelbinder },

  { coordinates: [5.926504731161771, 51.77498403337049], name: 'wolfsberg', size: 0.2, src: wolfsberg },
  { coordinates: [5.934862, 51.768875], name: 'wijncentrum', size: 0.2, src: wijncentrum },

  // en arnhem...
  { coordinates: [5.916436338127539, 51.98593667077367], name: 'casparmodez', size: 0.2, src: casparmodez },
  { coordinates: [5.910210444773725, 51.97904154676428], name: 'eusebius', size: 0.2, src: eusebius },
  { coordinates: [5.896021010247807, 51.97243423883819], name: 'gemaal', size: 0.2, src: gemaal },
  { coordinates: [5.911671884650275, 51.97484860391265], name: 'johnfrost', size: 0.2, src: johnfrost },
  { coordinates: [5.9059183742802475, 51.989250444877115], name: 'lazyking', size: 0.2, src: lazyking },
  { coordinates: [5.904868697160907, 51.98058198727347], name: 'rozet', size: 0.2, src: rozet },
  { coordinates: [5.901243682707701, 51.98390887993281], name: 'stationArnhem', size: 0.2, src: stationArnhem },
  { coordinates: [5.913682166546664, 51.97904098711322], name: 'walburgiskerk', size: 0.2, src: walburgiskerk },
  { coordinates: [5.917942114017421, 51.98756557985379], name: 'looimolenArnhem', size: 0.2, src: looimolen }, // Note;this is in arnhem

  // Icons
  { coordinates: [5.843202150800494, 51.85762256347124], name: 'boot1', size: 0.2, src: boot },
  { coordinates: [5.862284748565969, 51.85142706274365], name: 'boot2', size: 0.2, src: boot },
  { coordinates: [5.866963654747991, 51.85123816212695], name: 'boot3', size: 0.2, src: boot },
  { coordinates: [5.875281710184623, 51.852768234324174], name: 'boot4', size: 0.2, src: boot },
  { coordinates: [5.928872948608102, 51.97077907709229], name: 'boot5', size: 0.2, src: boot },
  { coordinates: [5.934041533308431, 51.96894663688772], name: 'boot6', size: 0.2, src: boot },
  { coordinates: [5.848217448932473, 51.855167131687665], name: 'vrachtschip1', size: 0.4, src: vrachtschip },
  { coordinates: [5.860235815795505, 51.85184264130939], name: 'vrachtschip2', size: 0.4, src: vrachtschip },
  { coordinates: [5.8779116835932825, 51.85482713826514], name: 'vrachtschip3', size: 0.4, src: vrachtschip },
  { coordinates: [5.8957321013938895, 51.9817804317141], name: 'vrachtschip4', size: 0.4, src: vrachtschip },
  { coordinates: [5.90543161679102, 51.97686213217523], name: 'vrachtschip5', size: 0.4, src: vrachtschip },
  { coordinates: [5.914445307866913, 51.97266757286101], name: 'vrachtschip6', size: 0.4, src: vrachtschip },

  { coordinates: [5.876413210372277, 51.861041056878946], name: 'paardlinks', size: 0.2, src: paardlinks },
  { coordinates: [5.87674960231945, 51.860058974867286], name: 'paardrechts', size: 0.2, src: paardrechts },

  { coordinates: [5.846404057985012, 51.863183002614704], name: 'koelinks1', size: 0.2, src: koelinks },
  { coordinates: [5.880970710570637, 51.852354873014235], name: 'koelinks2', size: 0.2, src: koelinks },
  { coordinates: [5.88156023768704, 51.85450327742356], name: 'koelinks3', size: 0.2, src: koelinks },
  { coordinates: [5.846905979660789, 51.8622593200144], name: 'koerechts1', size: 0.2, src: koerechts },
  { coordinates: [5.883712011658616, 51.85594155864828], name: 'koerechts2', size: 0.2, src: koerechts },
  { coordinates: [5.880351707100232, 51.85168119966147], name: 'koerechts3', size: 0.2, src: koerechts },

  { coordinates: [5.878406267618317, 51.85231845849614], name: 'paraplu1', size: 0.2, src: paraplu },
  { coordinates: [5.881029663283016, 51.85413914830181], name: 'paraplu2', size: 0.2, src: paraplu },
  { coordinates: [5.858568680182714, 51.85379322290768], name: 'paraplu3', size: 0.2, src: paraplu },
  { coordinates: [5.8562695244306155, 51.85705209877409], name: 'paraplu4', size: 0.2, src: paraplu },
  { coordinates: [5.8537345578337465, 51.858016972040076], name: 'paraplu5', size: 0.2, src: paraplu },
  { coordinates: [5.9068720465100455, 51.97556499784747], name: 'paraplu6', size: 0.2, src: paraplu },

  { coordinates: [5.876726115338329, 51.85067977468893], name: 'slippers1', size: 0.2, src: slippers },
  { coordinates: [5.860779406864879, 51.85352012203299], name: 'slippers2', size: 0.2, src: slippers },
  { coordinates: [5.856122142651856, 51.85768928155292], name: 'slippers3', size: 0.2, src: slippers },
  { coordinates: [5.907253424337199, 51.97529709694476], name: 'slippers4', size: 0.2, src: slippers },

  { coordinates: [5.9735388, 51.7781103], name: 'tent1', size: 0.15, src: tent },
  { coordinates: [5.976322, 51.777457], name: 'tent2', size: 0.15, src: tent },
  { coordinates: [5.975174, 51.777162], name: 'tent3', size: 0.15, src: tent },
  { coordinates: [5.9323738, 51.7649138], name: 'druif1', size: 0.15, src: druif },
  { coordinates: [5.9347381, 51.7590183], name: 'druif2', size: 0.15, src: druif },
  { coordinates: [5.982622, 51.7701303], name: 'druif3', size: 0.15, src: druif },
  { coordinates: [5.931748, 51.756025], name: 'vos1', size: 0.15, src: vos },
  { coordinates: [5.949816, 51.749038], name: 'vos2', size: 0.15, src: vos },
  { coordinates: [5.919818, 51.775998], name: 'vos3', size: 0.15, src: vos },
  { coordinates: [5.86074, 52.091631], name: 'vos4', size: 0.15, src: vos },
  { coordinates: [5.902351, 51.773794], name: 'hert1', size: 0.15, src: hert },
  { coordinates: [5.943121, 51.750181], name: 'hert2', size: 0.15, src: hert },
  { coordinates: [5.82281, 52.06287], name: 'hert3', size: 0.15, src: hert },
  { coordinates: [5.906681858130327, 51.771556209025874], name: 'zwijn1', size: 0.15, src: zwijn },
  { coordinates: [5.853597, 52.076648], name: 'zwijn2', size: 0.15, src: zwijn },
  { coordinates: [5.819115, 52.088605], name: 'zwijn3', size: 0.15, src: zwijn },
];
